export default __webpack_public_path__ + "static/media/logo.88cb48a0.svg";